import React, { useCallback, useEffect, useRef, useState } from 'react';
import { Button, Container, Dropdown, FormControl } from 'react-bootstrap';
import AssociationsTable from './AssociationsTable';
import AssociationDetailPanel from './AssociationDetailPanel';

const VISIBILITY_OPTIONS = [
  { value: 'all', label: 'All associations' },
  { value: 'visible', label: 'Visible' },
  { value: 'hidden', label: 'Archived' },
];

const HoaDirectoryPanel = ({ setActiveTabItemsMetadata }) => {
  const [searchInput, setSearchInput] = useState('');
  const [searchQuery, setSearchQuery] = useState('');
  const [visibility, setVisibility] = useState('all');
  const [selectedAssociationId, setSelectedAssociationId] = useState(null);
  const [detailRefreshKey, setDetailRefreshKey] = useState(0);
  const debounceTimeoutRef = useRef(null);

  useEffect(
    () => () => {
      if (debounceTimeoutRef.current) {
        clearTimeout(debounceTimeoutRef.current);
      }
    },
    []
  );

  const handleSearchChange = useCallback(e => {
    const value = e.target.value;
    setSearchInput(value);

    if (debounceTimeoutRef.current) {
      clearTimeout(debounceTimeoutRef.current);
    }

    debounceTimeoutRef.current = setTimeout(() => {
      setSearchQuery(value.trim());
    }, 500);
  }, []);

  useEffect(() => {
    setSelectedAssociationId(null);
  }, [searchQuery]);

  const handleAssociationSelect = association => {
    setSelectedAssociationId(association._id);
  };

  const handleAssociationUpdate = updatedAssociation => {
    if (updatedAssociation?._id && selectedAssociationId === updatedAssociation._id) {
      setDetailRefreshKey(key => key + 1);
    }
  };

  const handleAssociationDeleted = associationId => {
    if (selectedAssociationId === associationId) {
      setSelectedAssociationId(null);
    }
  };

  return (
    <Container fluid className="h-100 py-3 px-md-3">
      <div className="pt-3 pb-3" style={{ paddingLeft: 24, paddingRight: 24 }}>
        <div className="d-flex mb-4 w-100">
          <div className="flex-grow-1">
            <FormControl
              size="sm"
              placeholder="Search by association, management company, order ID, or property address..."
              className="entity-table-input-field"
              value={searchInput}
              onChange={handleSearchChange}
            />
          </div>
          <div className="ml-2">
            <Dropdown drop="down-start" autoClose="true">
              <Dropdown.Toggle
                size="sm"
                variant="outline-dark"
                id="hoa-visibility-filter"
                className="entity-table-input-field d-flex align-items-center text-dark hover-light"
              >
                {VISIBILITY_OPTIONS.find(option => option.value === visibility)?.label}
              </Dropdown.Toggle>
              <Dropdown.Menu align="end" className="p-1">
                {VISIBILITY_OPTIONS.map(option => (
                  <Dropdown.Item
                    key={option.value}
                    as={Button}
                    size="sm"
                    variant=""
                    className="py-2 px-2 mr-1 d-flex align-items-center text-dark"
                    style={{ borderRadius: '12px' }}
                    onClick={e => {
                      e.preventDefault();
                      setVisibility(option.value);
                    }}
                  >
                    {option.label}
                  </Dropdown.Item>
                ))}
              </Dropdown.Menu>
            </Dropdown>
          </div>
        </div>

        <div className="row mx-0">
          {/* Left column: Associations Table */}
          <div className="col-12 col-lg-7 px-0 pr-lg-3">
            <AssociationsTable
              searchQuery={searchQuery}
              visibility={visibility}
              selectedAssociationId={selectedAssociationId}
              onAssociationSelect={handleAssociationSelect}
              onAssociationUpdate={handleAssociationUpdate}
              onAssociationDeleted={handleAssociationDeleted}
              setActiveTabItemsMetadata={setActiveTabItemsMetadata}
            />
          </div>

          {/* Right column: Detail Panel */}
          <div className="col-12 col-lg-5 px-0 pl-lg-3 mt-4 mt-lg-0">
            <div style={{ flexShrink: 0 }}>
              <AssociationDetailPanel
                associationId={selectedAssociationId}
                refreshKey={detailRefreshKey}
              />
            </div>
          </div>
        </div>
      </div>
    </Container>
  );
};

export default HoaDirectoryPanel;
